import type { AreaData } from '@/server/transformers/EntityTransformers/areaTransformer';

export function getGradientColorsViaAndTo(area: AreaData | null) {
  if (!area) {
    return `background: rgba(0,0,0,0);background: linear-gradient(0deg, var(--activesection-alpha) 0%, rgba(255,255,255,0) 100%);`;
  } else {
    return `background: rgba(0,0,0,0);background: linear-gradient(0deg, var(--${area.id}-alpha) 0%, rgba(255,255,255,0) 100%);`;
  }
}
